import React from 'react';
import CollectionImageProp from './properties/collection-image';
import './scss/collection-image-small.scss';

function CollectionImageSmall({ collection }: CollectionImageProp): React.ReactElement {
  const collectionHref = `/collection?id=${collection.collectionId}`;
  const imageUrl = collection?.imageUrl ? collection?.imageUrl : collection?.image;
  return (
    <div className="collection-image-box-small">
      <a href={collectionHref} className="rounded">
        <img
          alt="EDS NFT"
          src={imageUrl}
          className="rounded-circle image-fill-smaller"
        />
        <p className="title">{collection.name}</p>
      </a>
    </div>
  );
}

export default CollectionImageSmall;
